<div #header></div>
<div pexOrientation><router-outlet></router-outlet></div>

<!-- <pex-dialog-overlay></pex-dialog-overlay> -->
<pex-toast-overlay></pex-toast-overlay>
